import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';


import { Helmet } from 'react-helmet-async';
// @mui
import { Typography, Stack, Button, Box, Grid } from '@mui/material';



// sections

import CustomSnackBar from '../components/snackbar';


// ----------------------------------------------------------------------

const ResetSuccess = () => {
  const { user } = useParams()
  const navigate = useNavigate()

  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)


  return (
    <>
      <Helmet>
        <title>Password Success | Teller One </title>
      </Helmet>
      <Grid container sx={{ height: '100vh', width: '100vw' }}>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', mx: {xs:2, sm:8}, position: 'relative' }}>

            <Stack mt={5} spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant='h3'>Password reset successful!</Typography>
              <Button sx={{ borderRadius: 4, width: 250 }} onClick={() => navigate( user === 'superadmin' ? '/login/superadmin' : '/login')} variant="contained">
                Back to login
              </Button>
            </Stack>

          </Box>

        </Grid>
      </Grid>
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
    </>
  );
}
export default ResetSuccess;